import { render, staticRenderFns } from "./PromoSettings.vue?vue&type=template&id=e1cdde02"
import script from "./PromoSettings.vue?vue&type=script&lang=ts"
export * from "./PromoSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports